<template>
  <div class="mx-3">
    <v-row>
      <v-spacer />
      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in employee's name here"
          append-icon="search"
          label="Search Employee Probations"
          hide-no-data
          hide-selected
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :search="search"
      :items="newPositionProbations"
      :loading="loading"
    >
      <template v-slot:item.start_date="{ item }">
        <span>{{ $moment(item.start_date).format('D MMM YYYY') }}</span>
      </template>

      <template v-slot:item.end_date="{ item }">
        <span>{{ $moment(item.end_date).format('D MMM YYYY') }}</span>
      </template>

      <template v-slot:item.department.name="{ item }">
        <span>{{ item.department? item.department.name:'N/A' }}</span>
      </template>

      <template v-slot:item.pass_or_fail="{ item }">
        <span
          v-if="item.pass_or_fail"
          class="font-weight-bold green--text"
        > Pass</span>
        <span
          v-else-if="item.pass_or_fail === null"
          class="font-weight-bold warning--text"
        > Pending Action</span>
        <span
          v-else
          class="font-weight-bold error--text"
        >Failed</span>
      </template>

      <template v-slot:item.action="{ item }">
        <probation-pending-dialog-edit
          v-if="$hasPermissionTo(['update probations'])"
          :probation="item"
          @updated="loadProbations"
        />
        <probation-pending-dialog-confirm
          v-if="$hasPermissionTo(['confirm probations'])"
          :probation="item"
          @confirmed="loadProbations"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      ProbationPendingDialogEdit: () => import('@/components/hris/probation/pending/DialogEdit'),
      ProbationPendingDialogConfirm: () => import('@/components/hris/probation/pending/DialogConfirm'),
    },
    data () {
      return {
        loading: false,
        headers: [
          {
            text: 'Employee',
            align: 'left',
            value: 'employee.person.name',
          },
          {
            text: 'Probation Start Date',
            align: 'center',
            value: 'start_date',
          },
          {
            text: 'Probation End Date',
            align: 'center',
            value: 'end_date',
          },
          {
            text: 'Department',
            align: 'center',
            value: 'department.name',
          },
          {
            text: 'Position',
            align: 'left',
            value: 'position.name',
          },
          {
            text: 'Status',
            align: 'center',
            value: 'pass_or_fail',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: null,
        newPositionProbations: [],
      }
    },
    created () {
      this.loadProbations()
    },

    methods: {
      loadProbations () {
        this.loading = true
        this.$api.employeeProbations().list()
          .then(res => {
            let newPosition = []
            res.data.map(i => {
              if (i.type === 'new position') {
                newPosition.push(i)
                this.newPositionProbations = _.orderBy(newPosition, ['start_date'], ['desc'])
              }            
            })

            this.loading = false          
          })
      },
    },
  }
</script>
